import { IRoute } from '../types/route';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { routes } from '@/config';

const AppRouter = () => {
  return (
    <Routes>
      {routes.map((route: IRoute, index: number) => (
        <Route
          key={index}
          path={route.path}
          element={
            route.private ? (
              <PrivateRoute
                element={route.element}
                requiredPermissions={route.requiredPermissions}
                blockedWhenOrdersPaused={route.blockedWhenOrdersPaused}
              />
            ) : (
              route.element
            )
          }
        />
      ))}
    </Routes>
  );
};

export default AppRouter;
